import _ from 'lodash';

export default (fn?: (...args: any[]) => any, ...args: any[]) => _.isFunction(fn) && fn(...args);
